module.exports = __webpack_public_path__ + "static/media/akansha (1).c2de5cb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Artist/static/images/akansha (1).jpg
// module id = 112
// module chunks = 1